import { CreateExperimentPayload } from './types';

export const buildCreateExperimentPayload = (name: string): CreateExperimentPayload => {
  return { name };
};
